import React from "react";
import { AppContext } from "Context/AppContext";
import { useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";

type SearchBarCreateButtonProps = {
  id: string;
}

const SearchBarCreateButton = ({id}: SearchBarCreateButtonProps) => {
    const appData = useContext<any>(AppContext)
    const history = useHistory();

    const navigateToAttributeForm = () => {
      if (appData.pm.checkPermission("gmsattributes_update")) {
        if (window.location.pathname.includes("gms/taxonomy/attribute")) {
          appData.setEditingItem({
            form: "edit",
            id: "0",
          });
        } else {
          history.replace({
            pathname: `/gms/taxonomy/attribute/0`,
          });
        }
      } else {
        toast.info("You don't have permission to create the attribute");
      }
    };
  

    return (
      <div id={id} role="group">
        <button id="create-dropdown-btn" type="button" className="button-outlined" data-bs-toggle="dropdown" aria-expanded="false" style={{ padding: "8px 20px" }}>
          Create
        </button>
        <ul id="create-dropdown-menu" className="bg-white dropdown-menu" aria-labelledby="create-dropdown-btn" style={{ fontFamily: "Noto Sans", fontSize: "0.875rem" }}>
          <li id="category-type-item">
            <Link
              id="category-type-link"
              className="dropdown-item"
              to="#"
              onClick={() => {
                if (appData.pm.checkPermission("gmscategory_update")) {
                  appData.setCatType("CT");
                  
                  if (
                    window.location.pathname === "/gms/taxonomy/category" ||
                    window.location.pathname === "/gms/taxonomy/category/c" ||
                    window.location.pathname === "/gms/taxonomy/category/ct"
                  ) {
                    history.replace({ pathname: `/workspace/empty` });
                    setTimeout(() => {
                      history.replace({ pathname: `/gms/taxonomy/category/ct` });
                    }, 1000);
                  } else {
                    history.replace({ pathname: `/gms/taxonomy/category/ct` });
                  }
                } else {
                  toast.info("You don't have permission to create the category type");
                }
              }}
            >
              Category Type
            </Link>
          </li>
    
          <li id="category-item">
            <Link
              id="category-link"
              className="dropdown-item"
              to="#"
              onClick={() => {
                if (appData.pm.checkPermission("gmscategory_update")) {
                  appData.setCatType("C");
                  
                  if (
                    window.location.pathname === "/gms/taxonomy/category" ||
                    window.location.pathname === "/gms/taxonomy/category/c" ||
                    window.location.pathname === "/gms/taxonomy/category/ct"
                  ) {
                    history.replace({ pathname: `/workspace/empty` });
                    setTimeout(() => {
                      history.replace({ pathname: `/gms/taxonomy/category/c` });
                    }, 1000);
                  } else {
                    history.replace({ pathname: `/gms/taxonomy/category/c` });
                  }
                } else {
                  toast.info("You don't have permission to create the category");
                }
              }}
            >
              Category
            </Link>
          </li>
    
          <li id="attribute-item">
            <Link 
              id="attribute-link"
              className="dropdown-item" 
              to="#" 
              onClick={navigateToAttributeForm}
            >
              Attribute
            </Link>
          </li>
    
          <li id="rule-item">
            <Link
              id="rule-link"
              className="dropdown-item"
              to="#"
              onClick={() => {
                if (appData.pm.checkPermission("gmsrules_update")) {
                  history.replace({ pathname: `/gms/rule/edit/0` });
                } else {
                  toast.info("You don't have permission to create rule");
                }
              }}
            >
              Rule
            </Link>
          </li>
    
          <li id="product-item">
            <Link
              id="product-link"
              className="dropdown-item"
              to="#"
              onClick={() => {
                if (appData.pm.checkPermission("gmsproducts_update")) {
                  appData.reset();
                  history.replace({ pathname: `/gms/product/edit/0` });
                } else {
                  toast.info("You don't have permission to create the product");
                }
              }}
            >
              Product
            </Link>
          </li>
    
          <li id="smart-builder-item">
            <Link
              id="smart-builder-link"
              className="dropdown-item"
              to="#"
              onClick={() => {
                if (appData.pm.checkPermission("gmskbcapps_create")) {
                  history.replace({ pathname: `/gms/builder/edit/0` });
                } else {
                  toast.info("You don't have permission to create the builder");
                }
              }}
            >
              Smart Builder
            </Link>
          </li>
        </ul>
      </div>
    );
}

export default SearchBarCreateButton